import React from "react";
import { Table } from "react-bootstrap";

const DataTable = ({ columns, data }) => {
  return (
    <div
      className="table-responsive"
      style={{
        maxHeight: "clamp(300px, 45vh, 700px)",
        overflowY: "auto",
      }}
    >
      <Table
        hover
        className="custom-data-table"
        style={{ tableLayout: "fixed", width: "100%" }}
      >
        <thead>
          <tr>
            {columns.map((col, i) => (
              <th
                key={i}
                style={{
                  width: col.width || "auto",
                  ...col.headerStyle,
                }}
                className={`border-0 py-3 px-4 text-left font-semibold uppercase tracking-wide text-sm ${
                  col.headerClassName || ""
                }`}
              >
                {col.label}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {data.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {columns.map((col, colIndex) => (
                <td
                  key={colIndex}
                  style={{
                    width: col.width || "auto",
                    ...col.style,
                  }}
                  className={`py-3 px-4 ${
                    col.className || ""
                  }`}
                >
                  {col.render
                    ? col.render(row[col.key], row)
                    : row[col.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default DataTable;